import { Pressable, Text as RNText } from 'react-native';

import { cn } from '@/components/ui/cn';

import { blockedPressableProps } from './blockedPressableProps';
import { FieldClaimFrame, type FieldClaimState } from './FieldClaimFrame';

/**
 * A claim-gated "+ Add …" affordance. A collaborator can be mid-typing
 * content that hasn't committed yet — their claim gates the affordance so
 * both users don't author the same thing; overriding opens the local user's
 * own draft (`onPress` doubles as the override's opener).
 */
export function GatedAddAffordance({
  label,
  field,
  onPress,
  className,
}: {
  label: string;
  field?: FieldClaimState;
  onPress: () => void;
  className?: string;
}) {
  return (
    <FieldClaimFrame
      field={field}
      onBlockedPress={() => field?.blockedPress?.(onPress)}
      className={cn('self-start', className)}
    >
      <Pressable
        onPress={onPress}
        hitSlop={6}
        {...blockedPressableProps(field?.blocked ?? false)}
      >
        <RNText className="font-sans-semibold text-sm text-muted">{label}</RNText>
      </Pressable>
    </FieldClaimFrame>
  );
}
